import React from 'react';
import ConfirmationDialog from '../../ConfirmationDialog';

const UndoDialogBody = ({ selectedTasks }) => {
    return(
        <div className="sign-dialog">
        {selectedTasks.map(task =>
                <div key={task.taskId} className="sign-dialog--task">
            <div>TASK:</div>
    <div>{task.description}</div>
    </div>
)}
</div>
);
}

const TaskUndoDialog = ({ tasks, onClose, onAccept, isAdmin, ...props }) =>
<ConfirmationDialog
{...props}
onClose = { onClose }
cancelButton={{
    action: onClose,
        label: 'NO, CANCEL'
}}
acceptButton={{
    action: onAccept,
        label: 'YES, UNDO'
}}

signButtong={{
    action: onAccept,
        label: 'SIGN'
}}
header="Are you sure you want to undo the status on the following tasks?"
body={<UndoDialogBody selectedTasks={tasks} />}
isAdmin={isAdmin}
/>;

export default TaskUndoDialog;